import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrackerLineComponent, TrackerTooltipComponent } from './tracker-line.component';

import { MaterialsModule } from '@library/common/materials';

@NgModule({
   declarations: [ TrackerLineComponent, TrackerTooltipComponent ],
   imports: [
      CommonModule,
      MaterialsModule,
   ],
   exports: [ TrackerLineComponent ],
})
export class TrackerLineModule { }
